export default {
	"components.GotIt": "知道了",
	"components.OrderDetails": "訂單詳情",
	"components.ActivateTheContent": "激活內容",
	"components.NoActivationAddress": "無啟動位址！",
	"components.TheActivationCodeIsInvalid": "啟動碼失效",
	"components.TheActivationCodeIsInvalidEnteringTheActivationCodemaxErrorTimesTimesTheInvalidActivationCodeAccountWillBeLockedYouCurrentlyHavefailedTimesTimes": "該啟動碼無效， 輸入啟動碼{maxErrorTimes}次無效啟動碼帳戶將被鎖定，你當前還有{failedTimes}次機會",
	"components.YouveAlreadyUsedTheActivationCode": "你已使用過該啟動碼",
	"components.ClickOrderDetailsToViewTheOrderInformationOrYouCanActivateItInTheContentToBeActivated": "點擊【訂單詳情】查看訂單資訊，也可以在待激活內容中去啟動",
	"components.TheItemHasBeenRemovedFromTheShelves": "該商品已下架",
	"components.TheActivationCodeRedeemableGoodsHaveBeenRemovedFromTheShelvesAndCannotBeRedeemedIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "該啟動碼可兌換的商品已下架，無法進行兌換，如有疑問請聯繫客服處理",
	"components.TheActivationCodeIsAlreadyInUse": "該啟動碼已使用",
	"components.TheActivationCodeHasExpired": "該啟動碼已過期",
	"components.TheAccountHasBeenLocked": "該帳戶已被鎖定",
	"components.TheNumberOfTimesYouEnterTheWrongActivationCodeHasReachedTheUpperLimitTheAccountIsTemporarilyLockedTheLockDurationlockTimeDescIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "你輸入錯誤啟動碼次數已達上限，帳戶暫被鎖定，鎖定時長{lockTimeDesc}，如有疑問請聯繫客服處理",
	"components.TheActivationCodeIsLoggedOut": "該啟動碼已註銷",
	"components.TheActivationCodeIsNotYetValid": "該啟動碼還未生效",
	"components.TheActivationDidNotTakeEffectAtTheTimeOfEntryeffectiveDate": "該啟動未到生效時間，生效時間為：{effectiveDate}",
	"components.TheItemIsNotYetInEffect": "該商品還未生效",
	"components.TheProductHasNotYetReachedTheEffectiveTimeTheEffectiveTimeIseffectiveDate": "該商品還未到生效時間，生效時間為：{effectiveDate}",
	"components.YouveAlreadyRedeemedTheItem": "你已兌換過該商品",
	"components.TheItemHasBeenRedeemed": "該商品已兌換",
	"components.TheProductHasBeenRemovedFromTheShelvesAndCannotBeRedeemedIfYouHaveAnyQuestionsPleaseContactCustomerServiceToDealWithIt": "該商品已下架，無法進行兌換，如有疑問請聯繫客服處理",
	"components.PleaseUseTheMainAccountOfTheAffectionNumberToRedeemTheContent": "請使用親情號主賬號兌換內容",
	"components.YouArePrompted": "系統提示",
	"components.FailedToRedeemTheItem": "兌換商品失敗！",
	"components.SorryYouDoNotMeetTheNewUserPurchaseRulesPleaseGoToTheLoveToReadPublicAccountToBuyAfterRefund": "抱歉，您不滿足新使用者購買規則，請退款後前往“愛閱讀的叫叫”公眾號購買",
	"components.FailedToRedeemActivationCode": "兌換啟動碼失敗"
}